/**
 * Task mutations — status quick-toggle + full edit.
 *
 * Mirrors `PATCH /api/v1/tasks/{id}` in `src/aimemory/api/routers/tasks.py`.
 * For the edit form: only keys that appear in the payload are sent;
 * `null` is allowed and explicitly clears the corresponding column.
 */
import type { Task, TaskPriority, TaskStatus } from "../lib/types";
import { request } from "./client";

export function updateTaskStatus(taskId: string, status: TaskStatus): Promise<Task> {
  return request<Task>(`/api/v1/tasks/${encodeURIComponent(taskId)}`, {
    method: "PATCH",
    body: { status },
  });
}

export interface TaskEdit {
  title?: string;
  assignee?: string | null;
  deadline?: string | null;
  priority?: TaskPriority | null;
  status?: TaskStatus;
}

export function editTask(taskId: string, fields: TaskEdit): Promise<Task> {
  return request<Task>(`/api/v1/tasks/${encodeURIComponent(taskId)}`, {
    method: "PATCH",
    body: fields,
  });
}
